import { render, staticRenderFns } from "./LfGridComponent.vue?vue&type=template&id=2a2ca980"
import script from "./LfGridComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./LfGridComponent.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a2ca980')) {
      api.createRecord('2a2ca980', component.options)
    } else {
      api.reload('2a2ca980', component.options)
    }
    module.hot.accept("./LfGridComponent.vue?vue&type=template&id=2a2ca980", function () {
      api.rerender('2a2ca980', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/grids/LfGrid/LfGridComponent.vue"
export default component.exports